import PropTypes from 'prop-types';

import UserProgressBar from '../../CourseSpecificInfo/UserProgressBar/UserProgressBar';

import classes from './AcademyInfo.module.css';

const AcademyInfo = props => {
  return (
    <>
      <figure className={classes.imgCourse}>
        <img
          className={classes.img}
          src={props.data.imgPathBig}
          alt={props.data.nombre}
        />
      </figure>
      {props.accessCourse && (
        <div className={classes.userProgressContainer}>
          <UserProgressBar
            userAditionalTrack={props.userAditionalTrack}
            lessons={props.lessons}
          />
        </div>
      )}
      <p className={classes.courseTitle}>{props.data.nombre}</p>
      <p className={classes.courseSubtitle}>
        {props.data.nameEmisor}
      </p>
    </>
  );
};

AcademyInfo.propTypes = {
  // eslint-disable-next-line react/require-default-props
  data: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  userAditionalTrack: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  lessons: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  accessCourse: PropTypes.object
};

export default AcademyInfo;
